module.exports = __webpack_public_path__ + "img/004-vehicles.efe0c8b5.svg";